appealsSettings.classy.controller({
    name: 'AppealsSettingsController',
    inject: ['$scope', '$modal', '$rootScope', 'HelpSystemModelService', 'authServiceFactory', 'SchoolModelService'],
    init: function()
    {
        this.$.HelpSystemModelService = this.HelpSystemModelService;
        this.$.item = this.SchoolModelService.data[0];  
        this.$.SchoolModelService = this.SchoolModelService;
        this.$rootScope.model = this.SchoolModelService;
        this.$.astatus = this.$.item.appeal_status == 0 ? 0 : 1;
        console.log(this.$.item);
    },
    iframeModal: function()
    {
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/settings/parentApp/appealsQuestions/partials/iframe2Modal.html?v=" + versionNo,
            controller: "iframeModalModalController"
        });
    },
    submit: function(scope, instance, form)
    {
        if (form.$valid)
        {
            instance.options.factor  = .3;
            this.SchoolModelService.put(this.id, this.$.item, instance).then(function (response) {

            });
        }
        else
        {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) 
    {
        this.SchoolModelService.set(this.SchoolModelService.data);
        if (typeof callback !== 'undefined')
            callback();
    },
    activeChange: function(field)
    {
        if (field=='astatus') {
            this.$.item.appeal_status = this.$.astatus; 
        }
        this.$.item[field] = Number(this.$.item[field]);
    }
});


